import React from "react";
import { Switch, Typography, Box } from "@mui/material";

interface SettingsToggleRowProps {
  label: string;
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
}

/** One on/off row in Settings (Category Options, Tools) */
const SettingsToggleRow: React.FC<SettingsToggleRowProps> = ({
  label,
  checked,
  onChange,
  disabled,
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      background: "#F7F9FB",
      borderRadius: "8px",
      px: 2,
      py: 1.5,
      mb: 1.5,
    }}
  >
    <Typography
      sx={{
        fontWeight: 600,
        color: checked ? "#222" : "#B0B0B0",
        fontSize: "1.1rem",
        flexGrow: 1,
      }}
    >
      {label}
    </Typography>
    <Switch
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      sx={{
        mr: 2,
        "& .MuiSwitch-switchBase.Mui-checked": {
          color: "primary.main",
        },
        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
          backgroundColor: "primary.main",
        },
      }}
    />
  </Box>
);

export default SettingsToggleRow;
